import { ProviderMedicalRole, RematchReason } from '@uplift/types';
import { restClient } from '../client';

export type RematchReasonsResponse = {
  rematchReasons: RematchReason[];
};

export const getRematchReasons = (medicalRole: ProviderMedicalRole) => {
  return restClient.request<RematchReasonsResponse>('/api/v1/matching/rematch_reasons', {
    params: { medical_role: medicalRole },
  });
};
